const wrapEvent = (event) => ({
  on: (fn) => event.on(fn),
  off: (fn) => event.off(fn),
});
export default wrapEvent;
